(function(){
  'use strict';
  var root = document.getElementById('daily');
  if(!root) return;

  var tabs = root.querySelectorAll('#dailyTabs .tab');
  tabs.forEach(function(tab){
    tab.addEventListener('click', function(){
      tabs.forEach(function(t){
        var on = t === tab;
        t.setAttribute('aria-selected', on);
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        panel.hidden = !on;
        if(on){ panel.classList.remove('swap'); void panel.offsetWidth; panel.classList.add('swap'); }
      });
    });
  });

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if(!reduced && 'IntersectionObserver' in window){
    var targets = root.querySelectorAll('.coll__head, .p, .promise__row > div, .night__grid > div, .faq__intro, .proof__item');
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(!e.isIntersecting) return;
        e.target.classList.add('rise'); e.target.classList.remove('will-rise');
        io.unobserve(e.target);
      });
    }, { rootMargin:'0px 0px -6% 0px', threshold:.1 });
    targets.forEach(function(el, i){
      if(el.getBoundingClientRect().top > window.innerHeight){
        el.classList.add('will-rise');
        el.style.transitionDelay = (el.classList.contains('p') ? (i % 5) * 70 : 0) + 'ms';
        io.observe(el);
      }
    });
  }

  /* Horizon scrolls inside .page-wrapper, not the window - window.scrollY/scrollTo are
     always 0/no-ops here. Every scroll read or write must go through this element,
     which is what made the "previous" arrow and the back-to-top button silent no-ops.
     getBoundingClientRect() stays viewport-relative and needs no translation. */
  var scroller = document.querySelector('.page-wrapper') || document.scrollingElement || document.documentElement;

  function lerp(a,b,t){ return a + (b-a)*t; }
  var ease = reduced ? 1 : .1;
  var heroPin = document.getElementById('dailyHeroPin');
  var heroArt = document.getElementById('dailyHeroArt');
  var heroCtx = heroArt && heroArt.getContext ? heroArt.getContext('2d') : null;
  var heroContent = document.getElementById('dailyHeroContent');
  var night = document.getElementById('dailyNight');
  var coll = document.getElementById('daily-collection');
  var track = document.getElementById('dailyTrack');
  var viewport = document.getElementById('dailyViewport');
  var countEl = document.getElementById('dailyCount');
  var total = track.children.length;
  var course = 0, pC = 0;

  /* Hero: scroll scrubs a preloaded frame sequence on a canvas, not a <video> -
     browsers snap video.currentTime seeks to keyframes, so most scroll positions
     produced no visible change. Frames are packed into a few 5x5 sprite sheets
     (150 frames total, the whole clip) instead of 150 separate files, so the
     browser only makes a handful of requests. The sheets are served versionless
     from the Shopify CDN; renaming them there means changing HERO_SPRITE_BASE in
     lockstep or the hero goes black. */
  var HERO_FRAME_COUNT = 150;
  var HERO_GRID_COLS = 5, HERO_GRID_ROWS = 5;
  var HERO_PER_SPRITE = HERO_GRID_COLS * HERO_GRID_ROWS;
  var HERO_SPRITE_COUNT = Math.ceil(HERO_FRAME_COUNT / HERO_PER_SPRITE);
  var HERO_CELL_W = 1200, HERO_CELL_H = 514;
  var HERO_SPRITE_BASE = 'https://cdn.shopify.com/s/files/1/1098/9686/0039/files/daily-hero-sprite-';
  var heroSprites = [];
  var heroSpriteReady = [];
  var heroFrameIndex = -1;
  var heroCourse = 1;
  function drawHeroFrame(i){
    if(!heroCtx) return;
    i = Math.max(0, Math.min(HERO_FRAME_COUNT - 1, i));
    var spriteIdx = Math.floor(i / HERO_PER_SPRITE);
    while(spriteIdx >= 0 && !heroSpriteReady[spriteIdx]) spriteIdx--;
    if(spriteIdx < 0) return;
    var frameInSprite = Math.min(i, spriteIdx * HERO_PER_SPRITE + HERO_PER_SPRITE - 1);
    if(frameInSprite === heroFrameIndex) return;
    heroFrameIndex = frameInSprite;
    var cellIdx = frameInSprite % HERO_PER_SPRITE;
    var col = cellIdx % HERO_GRID_COLS, row = Math.floor(cellIdx / HERO_GRID_COLS);
    var img = heroSprites[spriteIdx];
    var cw = heroArt.width, ch = heroArt.height;
    var scale = Math.max(cw / HERO_CELL_W, ch / HERO_CELL_H);
    var dw = HERO_CELL_W * scale, dh = HERO_CELL_H * scale;
    var focusX = window.matchMedia('(max-width:860px)').matches ? .64 : 1;
    heroCtx.drawImage(img, col * HERO_CELL_W, row * HERO_CELL_H, HERO_CELL_W, HERO_CELL_H,
      (cw - dw) * focusX, (ch - dh) * .5, dw, dh);
  }
  if(heroCtx){
    for(let s = 0; s < HERO_SPRITE_COUNT; s++){
      let img = new Image();
      img.onload = function(){ heroSpriteReady[s] = true; if(heroFrameIndex < 0) drawHeroFrame(0); };
      img.src = HERO_SPRITE_BASE + (s + 1) + '.jpg';
      heroSprites.push(img);
    }
  }
  function sizeHeroCanvas(){
    if(!heroCtx) return;
    var r = heroArt.getBoundingClientRect();
    var dpr = Math.min(2, window.devicePixelRatio || 1);
    var w = Math.round(r.width * dpr), h = Math.round(r.height * dpr);
    if(w > 0 && h > 0 && (heroArt.width !== w || heroArt.height !== h)){
      heroArt.width = w; heroArt.height = h;
      heroFrameIndex = -1;
      drawHeroFrame(Math.round((hP || 0) * (HERO_FRAME_COUNT - 1)));
    }
  }
  function measureHero(){
    if(!heroPin) return;
    heroCourse = Math.max(1, Math.round(window.innerHeight * 2.2));
    heroPin.style.height = (window.innerHeight + heroCourse) + 'px';
    sizeHeroCanvas();
  }

  function measure(){
    coll.classList.add('is-pinned');
    course = Math.max(0, track.scrollWidth - viewport.clientWidth);
    coll.style.height = (window.innerHeight + course * 1.6) + 'px';
    track.style.transform = 'translate3d(' + (-pC * course).toFixed(1) + 'px,0,0)';
  }
  function setProgress(p){
    coll.style.setProperty('--panp', Math.max(.2, p).toFixed(3));
    countEl.textContent = '0' + Math.min(total, 1 + Math.round(p * (total - 1))) + ' / 0' + total;
  }
  measure();
  measureHero();
  window.addEventListener('resize', function(){ measure(); measureHero(); kick(); });
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(function(){ measure(); measureHero(); kick(); });

  var lC = .15, running = false;
  var hP = 0;
  /* Lamp glow: gx/gy is where the glow is centered (percent of the .night section),
     hoverB is the pointer-driven brightness boost - both lerp toward a pointer target
     so the lamp follows the cursor, on top of the scroll-driven brightness. */
  var gx = 72, gy = 42, tgx = gx, tgy = gy, hoverB = 0, tHoverB = 0;
  function tick(){
    var pT = 0;
    if(course > 0){
      var trajet = coll.offsetHeight - window.innerHeight;
      pT = trajet > 0 ? Math.min(1, Math.max(0, -coll.getBoundingClientRect().top / trajet)) : 0;
      pC = lerp(pC, pT, ease);
      track.style.transform = 'translate3d(' + (-pC * course).toFixed(1) + 'px,0,0)';
      setProgress(pC);
    }
    var hPt = heroPin ? Math.min(1, Math.max(0, -heroPin.getBoundingClientRect().top / heroCourse)) : 0;
    var r = night.getBoundingClientRect();
    var lT = Math.max(.15, Math.min(1, (window.innerHeight - r.top) / (window.innerHeight * .8)));
    if(r.bottom < 0) lT = .15;
    if(reduced){ lC = 1; hoverB = tHoverB; gx = tgx; gy = tgy; hP = hPt; }
    else{
      lC = lerp(lC, lT, .07);
      gx = lerp(gx, tgx, .08);
      gy = lerp(gy, tgy, .08);
      hoverB = lerp(hoverB, tHoverB, .08);
      /* Smoothing this instead of driving the frame index straight off scroll is what makes
         each product focus dissolve into the next rather than jump-cutting between shots. */
      hP = lerp(hP, hPt, .08);
    }
    drawHeroFrame(Math.round(hP * (HERO_FRAME_COUNT - 1)));
    if(heroPin){
      /* Bridges the hard dark-hero -> light-page cut at hand-off: the bottom fade only
         ramps in during the last 16% of the pin, right before it unsticks, instead of
         sitting over the video for the whole scrub and washing out every frame. */
      var heroFadeT = Math.max(0, Math.min(1, (hP - .84) / .16));
      heroPin.style.setProperty('--herofade', heroFadeT.toFixed(3));
    }
    if(heroContent){
      var fade = Math.max(0, 1 - hP / .16);
      heroContent.style.opacity = fade.toFixed(3);
      heroContent.style.transform = 'translate3d(0,' + ((1 - fade) * -16).toFixed(1) + 'px,0)';
      heroContent.style.pointerEvents = fade < .05 ? 'none' : '';
    }
    night.style.setProperty('--lamp', Math.max(lC, hoverB).toFixed(3));
    night.style.setProperty('--gx', gx.toFixed(1) + '%');
    night.style.setProperty('--gy', gy.toFixed(1) + '%');
    var moving = Math.abs(pT-pC) > .0005 || (!reduced && (Math.abs(hPt-hP) > .0008 || Math.abs(lT-lC) > .001 || Math.abs(tgx-gx) > .05 || Math.abs(tgy-gy) > .05 || Math.abs(tHoverB-hoverB) > .001));
    if(moving) requestAnimationFrame(tick); else running = false;
  }
  function kick(){ if(!running){ running = true; requestAnimationFrame(tick); } }
  document.addEventListener('scroll', kick, { passive:true, capture:true });
  window.addEventListener('scroll', kick, { passive:true });
  kick();

  /* Lamp follows the cursor: hovering the night section brightens it and slides
     its glow toward the pointer, echoing "la lumiere suit votre journee". */
  if(!reduced){
    night.addEventListener('pointermove', function(e){
      var r = night.getBoundingClientRect();
      tgx = Math.min(100, Math.max(0, ((e.clientX - r.left) / r.width) * 100));
      tgy = Math.min(100, Math.max(0, ((e.clientY - r.top) / r.height) * 100));
      tHoverB = 1;
      kick();
    });
    night.addEventListener('pointerleave', function(){ tHoverB = 0; tgx = 72; tgy = 42; kick(); });
  }

  /* Drag-to-browse, prev/next arrows, back-to-top */
  function getTrajet(){ return coll.offsetHeight - window.innerHeight; }
  function currentProgress(){
    var trajet = getTrajet();
    if (trajet <= 0) return 0;
    return Math.min(1, Math.max(0, -coll.getBoundingClientRect().top / trajet));
  }
  function scrollToProgress(p, smooth){
    var trajet = getTrajet();
    if (trajet <= 0) return;
    p = Math.min(1, Math.max(0, p));
    var collTop = coll.getBoundingClientRect().top + scroller.scrollTop;
    scroller.scrollTo({ top: collTop + p * trajet, behavior: smooth ? 'smooth' : 'auto' });
  }

  /* Only engage drag-scroll past a movement threshold, so plain clicks on
     product links/buttons inside the viewport are never swallowed by
     setPointerCapture. */
  var DRAG_THRESHOLD = 6;
  var dragCandidate = false, dragging = false, startX = 0, startY = 0, startScroll = 0, dragTrajet = 0, activePointerId = null;
  viewport.addEventListener('pointerdown', function(e){
    if (e.button === 2) return;
    dragTrajet = getTrajet();
    if (dragTrajet <= 0) return;
    dragCandidate = true;
    dragging = false;
    startX = e.clientX;
    startY = e.clientY;
    startScroll = scroller.scrollTop;
    activePointerId = e.pointerId;
  });
  viewport.addEventListener('pointermove', function(e){
    if (!dragCandidate) return;
    var dx = e.clientX - startX;
    if (!dragging) {
      var dy = e.clientY - startY;
      if (Math.abs(dx) < DRAG_THRESHOLD && Math.abs(dy) < DRAG_THRESHOLD) return;
      dragging = true;
      viewport.classList.add('is-dragging');
      viewport.setPointerCapture(activePointerId);
    }
    scroller.scrollTop = startScroll - dx * (dragTrajet / Math.max(1, course));
  });
  function endDrag(){ dragCandidate = false; if(dragging){ dragging = false; viewport.classList.remove('is-dragging'); } }
  viewport.addEventListener('pointerup', endDrag);
  viewport.addEventListener('pointercancel', endDrag);

  var step = 1 / Math.max(1, total - 1);
  var prevBtn = document.getElementById('dailyPrev');
  var nextBtn = document.getElementById('dailyNext');
  if(prevBtn) prevBtn.addEventListener('click', function(){ scrollToProgress(currentProgress() - step, true); });
  if(nextBtn) nextBtn.addEventListener('click', function(){ scrollToProgress(currentProgress() + step, true); });

  var backTop = document.getElementById('dailyBackToTop');
  if(backTop){
    backTop.addEventListener('click', function(){ scroller.scrollTo({ top:0, behavior:'smooth' }); });
    var onScroll = function(){ backTop.classList.toggle('show', scroller.scrollTop > window.innerHeight * .8); };
    document.addEventListener('scroll', onScroll, { passive:true, capture:true });
    window.addEventListener('scroll', onScroll, { passive:true });
    onScroll();
  }
})();